export const ERROR_TIMEOUT = 6000;
// 7660 upload list 호출 주기 단축
export const UPLOADING_QUEUE_UPDATE_INTERVAL =
  process.env.REACT_APP_ENV === "production" ||
  process.env.REACT_APP_ENV === "staging"
    ? 30 * 1000
    : 10 * 1000;
